import { Box, Grid, useTheme } from '@mui/material';
import FlexBox from 'components/flexbox/FlexBox';
import { Small } from 'components/Typography';
import { ChevronDown, ChevronRight, CornerDownRight } from 'lucide-react';
import { useState } from 'react';
import ReversePagination from '../../components/ReversePagination';

// Dummy Data matching the image description
const dummyData = [
  {
    id: 1,
    user: { name: '마에바', avatar: null }, // Avatar logic can be added
    post: '이거 진짜 자영업하시는분들한테 도움되는거에요?',
    commentCount: 24,
    board: '꿀정보',
    date: '2025-11-21 10:11',
    action: '삭제',
    isExpanded: false,
    comments: [
      {
        id: 11,
        user: { name: '람쥐썬더' },
        content: '댓글입니다 댓글입니다 댓글입니다',
        date: '2025-11-21 10:11',
        action: '삭제',
      },
      {
        id: 12,
        user: { name: '야호다람쥐' },
        content: '안녕하세요. 도움됩니다. 이상 다람쥐였습니다.',
        date: '2025-11-21 10:11',
        action: '삭제',
      },
      {
        id: 13,
        user: { name: '송이다3432' },
        content: '우와 신기해요',
        date: '2025-11-21 10:11',
        action: '삭제',
      },
    ],
  },
  {
    id: 2,
    user: { name: '마에바' },
    post: '이거 진짜 자영업하시는분들한테 도움되는거에요?',
    commentCount: 654,
    board: '꿀정보',
    date: '2025-11-21 10:11',
    action: '삭제',
    comments: [
      {
        id: 21,
        user: { name: '람쥐썬더' },
        content: '댓글입니다 댓글입니다 댓글입니다',
        date: '2025-11-21 10:11',
        action: '삭제',
      },
      {
        id: 22,
        user: { name: '야호다람쥐' },
        content: '안녕하세요. 도움됩니다. 이상 다람쥐였습니다.',
        date: '2025-11-21 10:11',
        action: '삭제',
      },
    ], // Assuming empty or not shown for this example
  },
  {
    id: 3,
    user: { name: '마에바' },
    post: '이거 진짜 자영업하시는분들한테 도움되는거에요?',
    commentCount: 0,
    board: '꿀정보',
    date: '2025-11-21 10:11',
    action: '삭제',
    comments: [],
  },
  {
    id: 4,
    user: { name: '마에바' },
    post: '이거 진짜 자영업하시는분들한테 도움되는거에요?',
    commentCount: 0,
    board: '꿀정보',
    date: '2025-11-21 10:11',
    action: '삭제',
    comments: [],
  },
  {
    id: 5,
    user: { name: '마에바' },
    post: '이거 진짜 자영업하시는분들한테 도움되는거에요?',
    commentCount: 4,
    board: '꿀정보',
    date: '2025-11-21 10:11',
    action: '삭제',
    comments: [
      {
        id: 51,
        user: { name: '야호다람쥐' },
        content: '안녕하세요. 도움됩니다. 이상 다람쥐였습니다.',
        date: '2025-11-21 10:11',
        action: '삭제',
      },
      {
        id: 52,
        user: { name: '야호다람쥐' },
        content: '안녕하세요. 도움됩니다. 이상 다람쥐였습니다.',
        date: '2025-11-21 10:11',
        action: '삭제',
      },
      {
        id: 53,
        user: { name: '야호다람쥐' },
        content: '안녕하세요. 도움됩니다. 이상 다람쥐였습니다.',
        date: '2025-11-21 10:11',
        action: '삭제',
      },
      {
        id: 54,
        user: { name: '야호다람쥐' },
        content: '안녕하세요. 도움됩니다. 이상 다람쥐였습니다.',
        date: '2025-11-21 10:11',
        action: '삭제',
      },
    ],
  },
  {
    id: 6,
    user: { name: '마에바' },
    post: '이거 진짜 자영업하시는분들한테 도움되는거에요?',
    commentCount: 2,
    board: '꿀정보',
    date: '2025-11-21 10:11',
    action: '삭제',
    comments: [],
  },
  {
    id: 7,
    user: { name: '마에바' },
    post: '이거 진짜 자영업하시는분들한테 도움되는거에요?',
    commentCount: 1,
    board: '꿀정보',
    date: '2025-11-21 10:11',
    action: '삭제',
    comments: [
      {
        id: 71,
        user: { name: '야호다람쥐' },
        content: '안녕하세요. 도움됩니다. 이상 다람쥐였습니다.',
        date: '2025-11-21 10:11',
        action: '삭제',
      },
    ],
  },
  {
    id: 8,
    user: { name: '마에바' },
    post: '이거 진짜 자영업하시는분들한테 도움되는거에요?',
    commentCount: 33,
    board: '꿀정보',
    date: '2025-11-21 10:11',
    action: '삭제',
    comments: [
      {
        id: 81,
        user: { name: '람쥐썬더' },
        content: '댓글입니다 댓글입니다 댓글입니다',
        date: '2025-11-21 10:11',
        action: '삭제',
      },
    ],
  },
];

const PostListItem = ({ item, expanded, onExpand }) => {
  const theme = useTheme();

  return (
    <>
      {/* Main Post Row */}
      <Grid
        container
        alignItems="center"
        sx={{ padding: '16px 0', borderBottom: '1px solid #E5E7EB' }}
      >
        <Grid item xs={1.5}>
          <Small sx={{ fontWeight: 500, color: '#111827' }}>
            {item.user.name}
          </Small>
        </Grid>
        <Grid item xs={4}>
          <Small sx={{ fontWeight: 600, color: '#111827' }}>{item.post}</Small>
        </Grid>
        <Grid item xs={1.5}>
          <FlexBox
            alignItems="center"
            gap={0.5}
            onClick={() => item.commentCount > 0 && onExpand(item.id)}
            sx={{
              cursor: item.commentCount > 0 ? 'pointer' : 'default',
              color: theme.palette.primary.mainBlue,
            }}
          >
            <Small
              sx={{ fontWeight: 600, color: theme.palette.primary.mainBlue }}
            >
              {item.commentCount}개
            </Small>
            {item.commentCount > 0 &&
              (expanded ? (
                <ChevronDown size={16} />
              ) : (
                <ChevronRight size={16} />
              ))}
          </FlexBox>
        </Grid>
        <Grid item xs={1.5}>
          <Small sx={{ color: '#4B5563' }}>{item.board}</Small>
        </Grid>
        <Grid item xs={2}>
          <Small sx={{ color: '#6B7280' }}>{item.date}</Small>
        </Grid>
        <Grid item xs={1.5} sx={{ textAlign: 'right' }}>
          <Small
            sx={{ color: theme.palette.primary.mainBlue, cursor: 'pointer' }}
          >
            {item.action}
          </Small>
        </Grid>
      </Grid>

      {/* Expanded Comments */}
      {expanded &&
        item.comments.map(comment => (
          <Grid
            container
            key={comment.id}
            alignItems="center"
            sx={{
              padding: '12px 0',
              backgroundColor: '#F9FAFB',
              borderBottom: '1px solid #F3F4F6',
            }}
          >
            <Grid item xs={1.5} sx={{ pl: 2 }}>
              <Small sx={{ fontWeight: 500, color: '#4B5563' }}>
                {comment.user.name}
              </Small>
            </Grid>
            <Grid item xs={4} sx={{ display: 'flex', alignItems: 'center' }}>
              <CornerDownRight
                size={16}
                color="#9CA3AF"
                style={{ marginRight: '8px' }}
              />
              <Small sx={{ color: '#374151' }}>{comment.content}</Small>
            </Grid>
            <Grid item xs={1.5}></Grid>
            <Grid item xs={1.5}></Grid>
            <Grid item xs={2}>
              <Small sx={{ color: '#9CA3AF' }}>{comment.date}</Small>
            </Grid>
            <Grid item xs={1.5} sx={{ textAlign: 'right' }}>
              <Small
                sx={{
                  color: theme.palette.primary.mainBlue,
                  cursor: 'pointer',
                }}
              >
                {comment.action}
              </Small>
            </Grid>
          </Grid>
        ))}
    </>
  );
};

const PostListSection = () => {
  const [expandedIds, setExpandedIds] = useState([1, 5, 7]); // Default expanded for demo

  const handleExpand = id => {
    setExpandedIds(prev =>
      prev.includes(id) ? prev.filter(pid => pid !== id) : [...prev, id]
    );
  };

  return (
    <Box>
      <Box sx={{ overflowX: 'auto', minWidth: '100%' }}>
        <Box sx={{ minWidth: '800px' }}>
          {/* Header */}
          <Grid
            container
            sx={{ padding: '10px 0', borderBottom: '1px solid #E5E7EB' }}
          >
            <Grid item xs={1.5}>
              <Small sx={{ color: '#9CA3AF' }}>유저</Small>
            </Grid>
            <Grid item xs={4}>
              <Small sx={{ color: '#9CA3AF' }}>게시글</Small>
            </Grid>
            <Grid item xs={1.5}>
              <Small sx={{ color: '#9CA3AF' }}>댓글</Small>
            </Grid>
            <Grid item xs={1.5}>
              <Small sx={{ color: '#9CA3AF' }}>게시판</Small>
            </Grid>
            <Grid item xs={2}>
              <Small sx={{ color: '#9CA3AF' }}>작성일</Small>
            </Grid>
            <Grid item xs={1.5} sx={{ textAlign: 'right' }}>
              <Small sx={{ color: '#9CA3AF' }}>액션</Small>
            </Grid>
          </Grid>

          {/* List */}
          {dummyData.map(item => (
            <PostListItem
              key={item.id}
              item={item}
              expanded={expandedIds.includes(item.id)}
              onExpand={handleExpand}
            />
          ))}
        </Box>
      </Box>

      <FlexBox justifyContent="center" mt={2}>
        <ReversePagination totalItems={3} />
      </FlexBox>
    </Box>
  );
};

export default PostListSection;
